import React from "react";
import { useBranding } from "../context/BrandingContext";

const MockCompletedComponent = () => {
  const { colors } = useBranding();

  return (
    <div style={{ margin: "20px" }}>
      <div className="container main-border bg-white ">
        <div className="dashboard">
          <h1 style={{ color: colors?.primaryColor }}>Hy Dan,</h1>
          <h2>Welcome To Your Dashboard</h2>
          <p className="subtitle">
            Start your GRE prep journey with our free mock test.
          </p>
          <div className="cards">
            <div className="card">
              <h3>Free Test <span style={{ color: "#525252", fontSize: '14px', marginLeft: "8px" }}>(0 Free Test Available)</span></h3>
              <p>Get a feel for the GRE with our 16- question sample test</p>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 10V19.5C21 20.3285 20.3285 21 19.5 21H4.5C3.67158 21 3 20.3285 3 19.5V4.5C3 3.67158 3.67158 3 4.5 3H15"
                    stroke={colors.primaryColor}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 10L13 14L20.5 3.5"
                    stroke={colors.primaryColor}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p style={{ margin: 0, color: colors.primaryColor }}>
                  You’ve completed the free test, View your results below
                </p>
              </div>
            </div>
            <div className="card">
              <h3>Practice Test<span style={{ color: "#525252", fontSize: '14px', marginLeft: "8px" }}>(1 Free Test Available)</span></h3>
              <p>Get a feel for the GRE with our 16- question sample test</p>
              <button
                className="btn dark"
                style={{ display: "flex", alignItems: "center", gap: "6px", background: colors.buttonBg }}
              >
                <span >Start Test</span>
              </button>
            </div>


            <div className="card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 11.5H11V12.5H7V11.5ZM5 11.5H6V12.5H5V11.5ZM7 9H11V10H7V9ZM5 9H6V10H5V9ZM7 6.5H11V7.5H7V6.5ZM5 6.5H6V7.5H5V6.5Z"
                    fill="black"
                  />
                  <path
                    d="M12.5 2.5H11V2C11 1.73478 10.8946 1.48043 10.7071 1.29289C10.5196 1.10536 10.2652 1 10 1H6C5.73478 1 5.48043 1.10536 5.29289 1.29289C5.10536 1.48043 5 1.73478 5 2V2.5H3.5C3.23478 2.5 2.98043 2.60536 2.79289 2.79289C2.60536 2.98043 2.5 3.23478 2.5 3.5V14C2.5 14.2652 2.60536 14.5196 2.79289 14.7071C2.98043 14.8946 3.23478 15 3.5 15H12.5C12.7652 15 13.0196 14.8946 13.2071 14.7071C13.3946 14.5196 13.5 14.2652 13.5 14V3.5C13.5 3.23478 13.3946 2.98043 13.2071 2.79289C13.0196 2.60536 12.7652 2.5 12.5 2.5ZM6 2H10V4H6V2ZM12.5 14H3.5V3.5H5V5H11V3.5H12.5V14Z"
                    fill="black"
                  />
                </svg>
                <h3 style={{ margin: "0" }}>View Performance</h3>
              </div>
              <p>Review your performance on completed tests.</p>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <button
                  className="btn gray"
                  style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: colors.buttonBg }}
                >
                  <span>Go to Results</span>
                </button>
                <button
                  className="btn border-btn"
                  style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: "none", borderColor: colors.buttonBg }}
                >
                  <span >View Analysis</span>
                </button>
              </div>

            </div>

            <div className="card" style={{ background: colors.primaryColor, color: colors.textWhite }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="12" fill="white" />
                  <path d="M13 3L6 13h5v8l7-10h-5z" fill={colors.primaryColor} />
                </svg>
                <h3 style={{ margin: 0 }}>Upgrade Your Plan</h3>
              </div>
              <p style={{ color: colors.textWhite }}>
                Unlock more tests, detailed analytics, and personalized study
                plans.
              </p>
              <button
                className="btn dark"
              >
                <span >See Our Pricing</span>
              </button>
            </div>
          </div>


          {/* <div className="logout">
            <button className="btn gray">Logout Now</button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MockCompletedComponent;
